/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiaglabBill } from 'app/shared/model/diaglab-bill.model';
import { IHospitalPayment } from 'app/shared/model/hospital-payment.model';
import { IPackageSubscriber } from 'app/shared/model/package-subscriber.model';
import { IInsuranceClaim } from 'app/shared/model/insurance-claim.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';

export interface IDiaglabBillPayment {
  id?: string;
  paymentMethod?: string | null;
  transactionDetails?: string | null;
  paidAmount?: number | null;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string | null;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  settledAtHospital?: boolean | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  voided?: boolean | null;
  voidedReason?: string | null;
  voidedDate?: number | null;
  diaglabBill?: IDiaglabBill | null;
  hospitalPayment?: IHospitalPayment | null;
  subscriber?: IPackageSubscriber | null;
  claim?: IInsuranceClaim | null;
}

export const defaultValue: Readonly<IDiaglabBillPayment> = {
  active: false,
  settledAtHospital: false,
  voided: false,
};
